export const API_BASE_URL = 'http://aahdemo.bigstonesolutions.com/app/api';
export const APP_BASE_URL = 'http://aahdemo.bigstonesolutions.com/app/';